import React, { useEffect, useMemo } from "react";
import classnames from "classnames";
import { Fragment } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  TabContent,
  Table,
  TabPane,
} from "reactstrap";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import axios from "axios";
import { useState } from "react";
import LoadingPage from "../../TESTPage/LoadingPage";
import FadeIn from "react-fade-in/lib/FadeIn";
import { CheckPosition } from "../../Function/CheckPosition";
import { CheckSubAdmin } from "../../Function/CheckSubAdmin";
import { useNavigate } from "react-router-dom";
import UserDeduct from "../Deduct/UserDeduct";
import ViewSlipmoney from "../../Financial/ViewSlipmoney";
import { ConvertDate } from "../../Function/ConvertDate";
import UploadIncreaseSlip from "./UploadIncreaseSlip";

const API_URL = process.env.REACT_APP_API_CORS;

function UserTax(props) {
  const {userInfo} = props
  const token = GetCookieToken("userToken");
  const userData = GetCookieData("userData");
  const [activeTab, setActiveTab] = useState("1");
  const navigate = useNavigate();

  const [fileData, setFileData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // const [month, setMonth] = useState(null);
  const [dataSlipMoney, setDataSlipMoney] = useState([]);
  const [dataInfo, setDataInfo] = useState([]);
  const [year, setYaer] = useState(null);
  const [selectYear, setSelectYear] = useState(0);
  const [allYearUser, setAllYearUser] = useState(null)

  const fetchFileData = async () => {
    const url = `${API_URL}/api/taxSlip/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "year",
      "order[1]": "DESC",
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then((response) => {
        setFileData(response.data.result);
        const arr = []
        response.data?.result?.map(i => arr.push(i.year))
        const uniqueDataSet = [...new Set(arr)];
        setAllYearUser(uniqueDataSet);
        // setDataInfo(() => response.data.info);
        // setTotalPages(Math.ceil(response.data.info.totalRows / 10));
      })
      .catch((error) => console.error("Error:", error));
  };

  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      fetchFileData();
      fetchSlipIncrease();
      setLoading(false);
    }, 1500);
  }, []);

  const handleFetchYearTax = async (id, year) => {
    const url_api = `${API_URL}/api/taxSlip/user/${id}/${year}`;
    // const axios = require("axios");

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: url_api,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

  await axios
      .request(config)
      .then((response) => {
        window.open(API_URL + response.data.publicPath, "_blank");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (userInfo) {
      if (CheckPosition(userInfo?.position).length > 0 && CheckPosition(userInfo?.position).includes(1)){
        navigate("/assessment");
      }
    }
  }, [userInfo]);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const fetchSlipIncrease = async (value = undefined) => {
    const url = `${API_URL}/api/salary/increase/datatable`;
    const params = new URLSearchParams({
      page: currentPage,
      size: 10,
      "order[0]": "year",
      "order[1]": "DESC",
      "order[2]": "round",
      "order[3]": "DESC",
      "filter[user_idcard][0]": userInfo?.user_idcard,
    });
    // if (value && value != 0) {
    //   params.append("filter[year][0]", value)
    // }
    const config = {
      headers: { Authorization: `Bearer ${token}` },params
    };
    await axios
      .get(url, config)
      .then(response => {
        setDataSlipMoney(response?.data?.result)
        setDataInfo(response?.data?.info)
        setTotalPages(response?.data?.info?.totalPage);
      })
      .catch(error => console.log(error));
  };

  const yearForSelect = (param) => {
    setSelectYear(param)
    fetchSlipIncrease(param)
  }

  const headerTable = [
    { label: "รอบ" },
    { label: "เงินเดือนเดิม" },
    { label: "ฐานในการคำนวณ" },
    { label: "ระดับการประเมิน" },
    { label: "ร้อยละที่ได้เลื่อน" },
    { label: "จำนวนเงินที่ได้รับ", 
      child: 
        [
          { child_label: "เงินเดือนที่ได้เลื่อน"},
          { child_label: "เงินค่าตอบแทนพิเศษ" },
        ]
    },
    { label: "เงินเดือนที่ได้รับ" },
    { label: "กรณีไม่ได้รับการเลื่อนเงินเดือนเนื่องจาก (เหตุผล)" },
]

  useEffect(() => {
    fetchSlipIncrease()
  }, [currentPage])


  return (
    <Fragment>
      {loading ? (
        <LoadingPage />
      ) : (
        <FadeIn>
          <div className="">
            <Container fluid>
              <Breadcrumb
                title="หน้าหลัก"
                breadcrumbItem="การประเมินผลการปฏิบัติราชการ"
                breadcrumbText= {
                  activeTab === "1" ? "ข้อมูลใบเงินเดือน" :
                  activeTab === "2" ? "ข้อมูลใบภาษี" :
                  activeTab === "3" && "ข้อมูลใบลดหย่อนภาษี"  
                }
                isBack={false}
                isSubMenu={true}
                subMenuName= {
                  activeTab === "1" ? "ข้อมูลใบเงินเดือน" :
                  activeTab === "2" ? "ข้อมูลใบภาษี" :
                  activeTab === "3" && "ข้อมูลใบลดหย่อนภาษี" 
                }
                path="/assessment/?menu=tax_deduct_money_slip"
              />
              {/* <Breadcrumb title="Home" breadcrumbItem="ใบภาษี" /> */}
              {/* <h4 className="mb-2">ข้อมูลใบภาษี</h4> */}
              <Card>
                <CardBody className="d-flex justify-content-center">
                  <div style={{ width: windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) ? "100%" : "70%" }}>
                    <FadeIn>
                      <Nav tabs>
                        <Nav pills className="navtab-bg w-100" fill>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({active: activeTab === "1"})}
                              onClick={() => {toggle("1");}}
                            >
                              <h5>
                                ใบเงินเดือน
                              </h5>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({active: activeTab === "2",})}
                              onClick={() => {toggle("2")}}
                            >
                              <h5>
                                ใบภาษี
                              </h5>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({active: activeTab === "3"})}
                              onClick={() => {toggle("3");}}
                            >
                              <h5>
                                ใบลดหย่อนภาษี
                              </h5>
                            </NavLink>
                          </NavItem>
                          {CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 &&
                            (CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || 
                             CheckSubAdmin(userInfo?.positionSubAdmin).includes(3)) &&
                             <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({active: activeTab === "4"})}
                                onClick={() => {toggle("4");}}
                              >
                                <h5>
                                  ใบเลื่อนเงินเดือน
                                </h5>
                              </NavLink>
                            </NavItem>
                          }
                        </Nav>
                      </Nav>
                      <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                          <br />
                          <ViewSlipmoney userInfo={userInfo} windowSize={windowSize} yearForSlipIncrease={yearForSelect}/>
                        </TabPane>
                        <TabPane tabId="2">
                          <br />
                          <Row>
                            <Col lg={1} className="me-2">
                              <Label className="text-nowrap pe-2 mt-2 text-end" style={{fontSize: "16px"}}>ปี :</Label>
                            </Col>
                            <Col lg={4}>
                              <Input
                                id="date-end"
                                type="select"
                                onChange={e => setYaer(e.target.value)}
                              >
                                <option value={0}>กรุณาเลือก</option>
                                {allYearUser?.map((year, index) =>
                                  {
                                    return(
                                      <option key={index} value={year}>
                                          {year}
                                        </option>
                                    )
                                  }
                                )}
                              </Input>
                            </Col>
                            
                            { year && 
                                fileData?.map((item, idx) => {
                                  if (item.year == year) {
                                    return (
                                      <Col lg={4} className={windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) ? "mt-2" : ""}>
                                        <Button
                                          color="success"
                                          onClick={() => {
                                            handleFetchYearTax(userData.user_id, item.year);
                                          }}
                                        >
                                          <i className="fa-regular fa-print me-2"></i>
                                          พิมพ์
                                        </Button>
                                      </Col>
                                    ) 
                                  }
                                  
                                })
                            }
                          </Row>

                        </TabPane>
                        <TabPane tabId="3">
                          <br />
                          <UserDeduct userInfo={userInfo} windowSize={windowSize}/>
                        </TabPane>
                        <TabPane tabId="4">
                          <br />
                          <UploadIncreaseSlip userInfo={userInfo} windowSize={windowSize}/>
                        </TabPane>
                        
                      </TabContent>
                    </FadeIn>
                  </div>
                </CardBody>
              </Card>
              {activeTab === "1" && 
              <Fragment>
                <h4 className="mb-2">การเลื่อนเงินเดือน</h4>
                <Card>
                  <CardBody>
                    <div
                      // style={{ width: windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) ? "100%" : "70%" }}
                      >
                      <FadeIn>
                        <Table className="align-middle" striped style={{ fontSize: "15px" }} responsive>
                            <thead className="table-light" style={{verticalAlign: "middle", whiteSpace: "nowrap", transition: "background-color 0.3s"}}>
                            <tr>
                                <th rowSpan={2}>ลำดับ</th>
                                {headerTable.map((header, index) => {
                                  if (header.child) {
                                    return (
                                      <th className="text-center" colSpan={header.child.length}>{header.label}</th>
                                    )
                                  } else {
                                    return (
                                      <th className="text-center" key={index} rowSpan={2}>{header.label}</th>
                                    )
                                  }
                                }
                                )}
                            </tr>
                            <tr>
                              {headerTable.map((header, index) => {
                                if (header.child) {
                                  return(
                                    header.child.map(last_child => (<th className="text-center">{last_child.child_label}</th>))
                                  )
                                }
                              })}
                            </tr>
                            </thead>
                            <tbody>
                            {dataSlipMoney?.length === 0 ? (
                                <tr> <td colSpan={headerTable.length + 2} className="text-center fs-5"> ไม่มีข้อมูล </td> </tr>
                            ) : (
                              dataSlipMoney?.map((slip, index) => {
                                let cp = (currentPage - 1) * 10;
                                return (
                                    <tr key={index} >
                                        <td className="text-center">{index + cp + 1}</td>
                                        <td className="text-nowrap">{slip.round} / {slip.year}</td>
                                        <td className="text-center">{Number(slip.original_salary).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                        <td className="text-center">{Number(slip.cal_base).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                        <td className="text-center">{slip.assessment_level}</td>
                                        <td className="text-center">{Number(slip.percentage).toFixed(2)}</td>
                                        <td className="text-center">{Number(slip.amount_money).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                        <td className="text-center">{Number(slip.special_remuneration).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                        <td className="text-center">{Number(slip.salary_received).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                        <td>{slip.note ? slip.note : ""}</td>
                                    </tr>
                                );
                                })
                            )}
                            </tbody>
                        </Table>
                        {selectYear == 0 &&
                          <Row
                              className="mx-2"
                              style={{
                              display: "flex",
                              alignItems: "center",
                              }}
                          >
                              <Col xxl={4}>
                                  <h4 className="mb-0">
                                      <Badge className="badge-soft-primary me-1 fs-5">
                                          ทั้งหมด {dataInfo?.totalRows} รายการ
                                      </Badge>
                                  </h4>
                              </Col>
                              <Col xxl={8} className="d-flex justify-content-center justify-content-sm-end">
                                  <Pagination className="mt-3">
                                      <PaginationItem disabled={currentPage === 1}>
                                          <PaginationLink onClick={() => setCurrentPage(1)}> หน้าแรก </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem disabled={currentPage === 1}>
                                          <PaginationLink onClick={() => setCurrentPage(currentPage - 1)}> ย้อนกลับ </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem active> <PaginationLink>หน้า {currentPage} จาก {isNaN(totalPages) ? 1 : totalPages}</PaginationLink> </PaginationItem>
                                      <PaginationItem disabled={currentPage === dataInfo.totalPage || totalPages === 0}>
                                          <PaginationLink onClick={() => setCurrentPage(dataInfo.currentPage + 1)}> ถัดไป </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem disabled={currentPage === totalPages || totalPages === 0}>
                                          <PaginationLink onClick={() => setCurrentPage(dataInfo.totalPage)}> หน้าสุดท้าย </PaginationLink>
                                      </PaginationItem>
                                  </Pagination>
                              </Col>
                          </Row>}
                      </FadeIn>
                    </div>
                  </CardBody>
                </Card>
              </Fragment>
                 }
            </Container>
          </div>
        </FadeIn>
      )}
    </Fragment>
  );
}

export default UserTax;
